import { useContext } from 'react';

import Text from 'components/common/Text';
import Logo from 'components/signUpFunnel/Logo';

import BackButton from './BackButton';
import { ProgressBarContext } from './Contexts';

const MobileProgressBar = () => {
  const { progress } = useContext(ProgressBarContext);

  return (
    <section className="h-18 sticky inset-0 z-one mb-0 flex items-center justify-between border border-transparent bg-white-100 px-6 py-4 shadow bp1:hidden md:mb-12">
      <div className="flex w-10 shrink-0 items-center justify-center">
        <BackButton />
      </div>
      <div className="grow text-center uppercase leading-4 tracking-wider">
        <Text brandStylesOverrides="h7 text-secondary">
          Step {progress.stepNumber} of {progress.totalSteps}
        </Text>
        <Text brandStylesOverrides="h7">
          <Text htmlElement="span" brandStylesOverrides="text-light" className="pr-1">
            Up next:
          </Text>
          {progress.nextStep}
        </Text>
      </div>
      <div className="flex w-10 items-center justify-end">
        <Logo width="40" height="34" />
      </div>
    </section>
  );
};

export default MobileProgressBar;
